/** Confirmed/draft section shape from `orders/counts` API attributes. */
export interface OrderCountsSection {
    readonly count?: number;
    readonly list?: readonly unknown[];
}

/**
 * Whether the API section has order types to show in a sub-menu.
 * Prefer `list.length` over `count` — `count` can be non-zero while `list` is empty.
 */
export function hasOrderTypeList(
    section: OrderCountsSection | undefined | null
): boolean {
    return Array.isArray(section?.list) && section.list.length > 0;
}
